'use client';
import { useState, useEffect } from 'react';
import Image from 'next/image';

// Store
import useStore from '@store';

// Icons
import { IoChevronDownSharp } from 'react-icons/io5';

// Assets
import $defaultAvatar from '@assets/images/general/def-parent-avatar.webp';

export default function Avatar() {
	const $state = useStore();
	const { user } = $state?.auth || {};
	const [imgSrc, setImgSrc] = useState(user?.profile?.avatar_url || $defaultAvatar);

	// Update image source when user changes
	useEffect(() => {
		const newAvatarUrl = user?.profile?.avatar_url || user?.avatar_url;
		if (newAvatarUrl && newAvatarUrl !== imgSrc) {
			setImgSrc(newAvatarUrl);
		}
	}, [user]);

	return (
		<div
			className={`relative flex flex-row items-center justify-center rounded-full border-2 border-white size-14 bg-[#B2B2F0] cursor-pointer`}>
			<Image
				src={imgSrc}
				alt='avatar'
				width={100}
				height={100}
				className={`h-full w-auto`}
				onError={() => {
					setImgSrc($defaultAvatar);
				}}
			/>
			<div
				className={`absolute -right-3 bg-[#5858F2] group-hover:bg-white transition-all duration-300 rounded-full size-6 flex flex-row items-center justify-center`}>
				<IoChevronDownSharp className={`text-white group-hover:text-[#5858F2]`} />
			</div>
		</div>
	);
}
